import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { getTokensFromSSO } from '../../../shared/service/auth';
import { useLogin } from '../../../utilities/helper/useLogin';

export default function SSOSuccessfulRedirect() {
  const navigate = useNavigate();
  const { completeSSOLogin } = useLogin();
  const [failed, setFailed] = useState(false);
  const exchangeStarted = useRef(false);

  const { mutate } = useMutation({
    mutationFn: () => getTokensFromSSO(),
    onSuccess: async (tokens) => {
      const result = await completeSSOLogin(tokens);
      if (!result.success) {
        setFailed(true);
        navigate('/login');
      }
    },
    onError: () => {
      setFailed(true);
      navigate('/login');
    },
  });

  useEffect(() => {
    if (exchangeStarted.current) return;
    exchangeStarted.current = true;
    mutate();
  }, []);

  if (failed) {
    return (
      <div className="p-5">
        <div className="text-lg font-bold">
          Authentication failed. Redirecting…
        </div>
      </div>
    );
  }

  return <div className="p-5 text-lg font-bold">Authenticating...</div>;
}
